var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpfRarelyNever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-spf-rarely-never{fill:#7eac20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-spf-rarely-never",
    d: "M32.69,98.82a1.51,1.51,0,0,1-1.07-2.57L96,31.85A1.5,1.5,0,1,1,98.15,34L33.75,98.38A1.53,1.53,0,0,1,32.69,98.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-spf-rarely-never",
    d: "M73.91,91.36H56.09l-.45-.61c-.42-.58-10.32-14.2-8.43-25.7.83-5,4.15-8.84,9.62-11.1V52.63a3,3,0,0,1,3.09-2.91H70.08a3,3,0,0,1,3.09,2.91V54C78.64,56.21,82,60,82.79,65.05h0c1.89,11.5-8,25.12-8.43,25.7Zm-16.28-3H72.37c1.84-2.71,8.93-13.84,7.46-22.82-.7-4.24-3.62-7.32-8.67-9.15l-1-.36V52.74l-.09,0H59.92l-.09,0V56l-1,.36c-5.05,1.83-8,4.91-8.67,9.15C48.7,74.52,55.79,85.65,57.63,88.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-spf-rarely-never",
    d: "M68.27,44.93H56a3.08,3.08,0,0,1-3.07-3.08v-.13A3.08,3.08,0,0,1,56,38.64H68.27a3.08,3.08,0,0,1,3.07,3.08v.13A3.08,3.08,0,0,1,68.27,44.93ZM56,41.64a.08.08,0,0,0-.07.08v.13a.08.08,0,0,0,.07.08H68.27a.08.08,0,0,0,.07-.08v-.13a.08.08,0,0,0-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-spf-rarely-never",
    d: "M68.45,52.72h-6.9V47H60.34V42.7h9.32V47H68.45Zm-3.9-3h.9v-4h-.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpfRarelyNever);
export default __webpack_public_path__ + "static/media/spf-rarely-never.12f3752b.svg";
export { ForwardRef as ReactComponent };